module.exports = __webpack_public_path__ + "img/syukyaku-top-pa001sp.53458a83.png";